export const guardEnrollmentQrPrefix = "TC_GUARD_ENROLL_V1:";

export function canonicalJson(value: unknown): string {
  if (value === undefined) return "null";
  if (value === null || typeof value !== "object") return JSON.stringify(value);
  if (Array.isArray(value)) return `[${value.map(canonicalJson).join(",")}]`;
  return `{${Object.entries(value as Record<string, unknown>).filter(([, entry]) => entry !== undefined).sort(([left], [right]) => left < right ? -1 : left > right ? 1 : 0).map(([key, entry]) => `${JSON.stringify(key)}:${canonicalJson(entry)}`).join(",")}}`;
}

export function guardEventSigningPayload(event: Record<string, unknown>) {
  const { signature: _signature, payloadHash: _payloadHash, ...payload } = event;
  return canonicalJson(payload);
}

export function guardCredentialScopeAllowsGate(scope: { gateScope?: unknown; gateScopes?: unknown } | null | undefined, gateScope: string) {
  const explicitScopes = Array.isArray(scope?.gateScopes) ? scope.gateScopes.filter((value): value is string => typeof value === "string") : [];
  if (explicitScopes.length) return explicitScopes.includes("*") || explicitScopes.includes(gateScope);
  const declaredScope = typeof scope?.gateScope === "string" ? scope.gateScope : undefined;
  return !declaredScope || declaredScope === "*" || declaredScope === gateScope;
}
